export interface ProductDetail {
  id: number;
  name: string;
  tagline: string;
  originalPrice: number;
  salePrice: number;
  badge: string;
  category: string;
  description: string;
  highlights: string[];
  images: string[];
  sizes: { label: string; chest: string; waist: string; hip: string; length: string }[];
  material: string;
  careInstructions: string[];
  fitDescription: string;
  stylingTips: string[];
  relatedIds: number[];
}

export const productDetails: ProductDetail[] = [
  {
    id: 1,
    name: "都會氣質修身洋裝",
    tagline: "修飾曲線，氣質出眾",
    originalPrice: 5800,
    salePrice: 2980,
    badge: "新品",
    category: "洋裝系列",
    description: "以精選進口雪紡面料剪裁而成，腰部細緻打褶設計既修身又顯瘦，讓都會女性在任何場合都能散發優雅自信。垂墜感設計勾勒出完美的身體線條，是職場、聚會、日常都適合的萬能洋裝。",
    highlights: [
      "修身腰部打褶設計，顯瘦修飾效果極佳",
      "進口雪紡面料，輕盈垂墜不顯厚重",
      "膝下 5 公分長度，優雅又不失活動自在",
      "隱藏式後拉鍊，版型更為俐落",
      "適合職場、聚餐、逛街等多種場合"
    ],
    images: [
      "https://readdy.ai/api/search-image?query=elegant%20taiwanese%20designer%20women%20midi%20dress%20slim%20fit%20worn%20by%20mature%20woman%20minimalist%20cream%20beige%20background%20professional%20photography%20high%20quality%20fabric%20graceful%20silhouette%20front%20view&width=600&height=840&seq=pd001a&orientation=portrait",
      "https://readdy.ai/api/search-image?query=elegant%20women%20midi%20dress%20detail%20waist%20tuck%20fabric%20texture%20close%20up%20cream%20background%20taiwanese%20designer%20quality%20craftsmanship%20fashion%20photography&width=600&height=840&seq=pd001b&orientation=portrait",
      "https://readdy.ai/api/search-image?query=elegant%20mature%20taiwanese%20woman%20wearing%20midi%20dress%20street%20lifestyle%20soft%20light%20warm%20tone%20quality%20fashion%20editorial%20photography%20graceful%20posture&width=600&height=840&seq=pd001c&orientation=portrait"
    ],
    sizes: [
      { label: "S", chest: "84", waist: "68", hip: "90", length: "108" },
      { label: "M", chest: "88", waist: "72", hip: "94", length: "109" },
      { label: "L", chest: "93", waist: "77", hip: "99", length: "110" },
      { label: "XL", chest: "98", waist: "82", hip: "104", length: "111" }
    ],
    material: "主布：100% 進口雪紡（Chiffon）\n裡布：95% 聚酯纖維 + 5% 彈性纖維",
    careInstructions: [
      "建議手洗或洗衣袋機洗，冷水溫和程序",
      "不可漂白，不可烘乾",
      "低溫熨燙，勿直接熨燙面料",
      "建議平鋪或吊掛晾乾"
    ],
    fitDescription: "版型偏修身，建議依照實際腰圍選尺寸。身形較豐腴者建議選大一號，以確保穿著舒適度。模特兒身高 165cm，穿著 M 號拍攝。",
    stylingTips: [
      "搭配米白色針織小外套，可延伸至秋季穿著",
      "加上細皮帶束腰，進一步修飾腰部比例",
      "搭配楔形跟或細高跟鞋，拉長整體線條",
      "配上珍珠項鍊，整體氣質更為提升"
    ],
    relatedIds: [5, 6, 2]
  },
  {
    id: 2,
    name: "優雅職場西裝外套",
    tagline: "俐落有型，一件多穿",
    originalPrice: 6500,
    salePrice: 3480,
    badge: "熱銷",
    category: "外套系列",
    description: "以台灣設計師品牌經典剪裁為基礎，採用挺括精紡毛料打造而成。一字肩線設計強調女性肩頸美感，前排雙釦收腰，呈現俐落的都會形象，是職場與聚會兩用的百搭逸品。",
    highlights: [
      "精紡毛料，挺括有型不起皺",
      "雙釦收腰設計，修飾腰部線條",
      "袖口翻折細節，展現設計師品牌巧思",
      "內附同布料口袋，實用兼具美感",
      "百搭設計，與洋裝、長褲、牛仔褲皆適合"
    ],
    images: [
      "https://readdy.ai/api/search-image?query=elegant%20women%20blazer%20jacket%20tailored%20fit%20front%20view%20mature%20professional%20woman%20warm%20rose%20beige%20minimalist%20background%20taiwanese%20designer%20brand%20high%20quality%20detail&width=600&height=840&seq=pd002a&orientation=portrait",
      "https://readdy.ai/api/search-image?query=elegant%20women%20blazer%20jacket%20tailored%20back%20view%20detail%20sleeve%20cuff%20quality%20fabric%20taiwanese%20designer%20fashion%20mature%20sophisticated%20cream%20background&width=600&height=840&seq=pd002b&orientation=portrait",
      "https://readdy.ai/api/search-image?query=elegant%20mature%20taiwanese%20woman%20wearing%20blazer%20casual%20street%20style%20warm%20soft%20light%20editorial%20fashion%20photography%20graceful%20sophisticated%20quality%20outfit&width=600&height=840&seq=pd002c&orientation=portrait"
    ],
    sizes: [
      { label: "S", chest: "86", waist: "72", hip: "88", length: "62" },
      { label: "M", chest: "90", waist: "76", hip: "92", length: "63" },
      { label: "L", chest: "95", waist: "81", hip: "97", length: "64" },
      { label: "XL", chest: "100", waist: "86", hip: "102", length: "65" }
    ],
    material: "主布：60% 羊毛 + 40% 聚酯纖維\n裡布：100% 聚酯纖維",
    careInstructions: [
      "建議送洗乾洗（Dry Clean Only）",
      "勿機洗、勿漂白",
      "中溫熨燙，使用熨燙布墊保護面料",
      "建議吊掛存放，避免折疊變形"
    ],
    fitDescription: "版型修身合體，肩線設計較為標準，建議依照胸圍選尺寸。手臂較粗或肩寬較寬者建議選大一號。模特兒身高 168cm，穿著 M 號拍攝。",
    stylingTips: [
      "搭配品牌修身長褲，完整呈現套裝感",
      "配上印花絲巾，為職場造型增添變化",
      "搭配白色上衣與牛仔寬管褲，打造休閒優雅感",
      "卷起袖口，露出手錶，展現都會女性的時尚細節"
    ],
    relatedIds: [5, 1, 3]
  },
  {
    id: 3,
    name: "雪紡寬管顯瘦長褲",
    tagline: "顯瘦顯高，輕盈飄逸",
    originalPrice: 4200,
    salePrice: 2180,
    badge: "Outlet",
    category: "褲裝系列",
    description: "以進口雪紡面料打造的寬管長褲，腰部設計鬆緊加隱形拉鍊，穿脫方便又能修飾腰腹。寬鬆的褲管線條利用垂墜感創造視覺延伸效果，穿上後立即感受到輕盈修長的優雅姿態。",
    highlights: [
      "寬管剪裁，利用視覺效果拉長腿部線條",
      "腰部鬆緊設計，穿著舒適不束縛",
      "輕盈雪紡面料，不挑身材、走動飄逸",
      "高腰版型，修飾腰腹部位",
      "腳踝長度，搭配高跟鞋效果絕佳"
    ],
    images: [
      "https://readdy.ai/api/search-image?query=elegant%20women%20wide%20leg%20chiffon%20pants%20full%20front%20view%20flowy%20silhouette%20mature%20woman%20cream%20white%20background%20taiwanese%20designer%20fashion%20graceful%20high%20quality%20fabric&width=600&height=840&seq=pd003a&orientation=portrait",
      "https://readdy.ai/api/search-image?query=women%20wide%20leg%20chiffon%20pants%20waist%20detail%20fabric%20texture%20close%20up%20cream%20background%20taiwanese%20designer%20quality%20fashion%20draping%20silhouette&width=600&height=840&seq=pd003b&orientation=portrait",
      "https://readdy.ai/api/search-image?query=elegant%20mature%20taiwanese%20woman%20wide%20leg%20pants%20street%20style%20warm%20soft%20light%20graceful%20movement%20fashion%20photography%20quality%20outfit%20editorial&width=600&height=840&seq=pd003c&orientation=portrait"
    ],
    sizes: [
      { label: "S", chest: "-", waist: "64-72", hip: "94", length: "96" },
      { label: "M", chest: "-", waist: "68-76", hip: "98", length: "97" },
      { label: "L", chest: "-", waist: "72-80", hip: "102", length: "98" },
      { label: "XL", chest: "-", waist: "76-84", hip: "106", length: "99" }
    ],
    material: "主布：100% 進口雪紡（Chiffon）\n裡褲：95% 聚酯纖維 + 5% 彈性纖維",
    careInstructions: [
      "建議手洗或洗衣袋機洗，冷水溫和程序",
      "不可漂白，不可烘乾",
      "低溫熨燙，勿直接熨燙面料",
      "建議平鋪或吊掛晾乾"
    ],
    fitDescription: "腰圍可依鬆緊調整，建議依照實際腰圍選擇。臀圍較大者請參考臀圍數據選尺寸，以確保穿著舒適。模特兒身高 165cm，穿著 M 號拍攝。",
    stylingTips: [
      "搭配修身上衣或雪紡罩衫，均衡上下比例",
      "搭配細跟高跟鞋，讓整體線條更為修長",
      "配上短版西裝外套，打造時尚層次感",
      "純色款可依季節更換上衣顏色，變化造型"
    ],
    relatedIds: [4, 5, 8]
  },
  {
    id: 4,
    name: "氣質圓領針織上衣",
    tagline: "柔軟舒適，百搭經典",
    originalPrice: 3200,
    salePrice: 1580,
    badge: "特價",
    category: "上衣系列",
    description: "採用優質精梳棉針織製成，手感細膩柔軟。圓領設計修飾頸部線條，衣身略為修身但不緊繃，能完美勾勒出女性優雅的身體線條。是一件四季皆可上場的百搭衣橱必備單品。",
    highlights: [
      "精梳棉針織，親膚柔軟不起球",
      "圓領設計，修飾頸部線條更顯纖細",
      "修身但有彈性，活動不受限",
      "多色可選，輕鬆搭配各款下著",
      "洗滌後不易變形，耐久品質"
    ],
    images: [
      "https://readdy.ai/api/search-image?query=elegant%20women%20knit%20top%20round%20neck%20front%20view%20soft%20fabric%20mature%20woman%20warm%20beige%20background%20taiwanese%20designer%20classic%20minimalist%20quality&width=600&height=840&seq=pd004a&orientation=portrait",
      "https://readdy.ai/api/search-image?query=women%20knit%20top%20fabric%20detail%20texture%20close%20up%20soft%20quality%20craftsmanship%20cream%20background%20taiwanese%20designer%20fashion&width=600&height=840&seq=pd004b&orientation=portrait",
      "https://readdy.ai/api/search-image?query=elegant%20mature%20taiwanese%20woman%20wearing%20knit%20top%20casual%20street%20style%20warm%20light%20editorial%20fashion%20photography%20graceful%20natural%20pose&width=600&height=840&seq=pd004c&orientation=portrait"
    ],
    sizes: [
      { label: "S", chest: "82", waist: "70", hip: "86", length: "58" },
      { label: "M", chest: "86", waist: "74", hip: "90", length: "59" },
      { label: "L", chest: "91", waist: "79", hip: "95", length: "60" },
      { label: "XL", chest: "96", waist: "84", hip: "100", length: "61" }
    ],
    material: "100% 精梳棉（Combed Cotton）",
    careInstructions: [
      "可機洗，冷水溫和程序",
      "建議洗衣袋保護，避免拉扯變形",
      "不可漂白，低溫烘乾",
      "中溫熨燙或蒸氣整燙"
    ],
    fitDescription: "版型略為修身，有彈性。建議依照胸圍選尺寸，胸部較豐滿者可選大一號。模特兒身高 163cm，穿著 S 號拍攝。",
    stylingTips: [
      "搭配高腰A字裙，展現甜美優雅感",
      "塞進高腰長褲，打造俐落都會形象",
      "外搭針織開衫，層次感加分",
      "配上絲巾或領巾，讓簡單的上衣更有設計感"
    ],
    relatedIds: [1, 3, 7]
  },
  {
    id: 5,
    name: "典雅修身套裝組",
    tagline: "上下搭配，完美比例",
    originalPrice: 8900,
    salePrice: 4580,
    badge: "新品",
    category: "套裝系列",
    description: "以同款精紡布料打造的上下套裝，外套與長褲採用一致的材質與工藝，呈現完整的品牌設計語彙。外套腰線收束設計搭配垂直褲管，讓整體比例更為完美，是熟齡女性最受歡迎的品牌經典款式之一。",
    highlights: [
      "上下同款布料，整體感強且顯品味",
      "外套收腰設計，修飾腰部曲線",
      "直筒褲管，視覺拉長下半身比例",
      "品牌經典款式，歷年暢銷不衰",
      "可分開搭配其他單品，使用靈活"
    ],
    images: [
      "https://readdy.ai/api/search-image?query=elegant%20women%20matching%20suit%20set%20jacket%20pants%20full%20view%20mature%20professional%20woman%20dusty%20rose%20gray%20tone%20taiwanese%20designer%20brand%20quality%20fabric%20graceful%20front%20view%20editorial&width=600&height=840&seq=pd005a&orientation=portrait",
      "https://readdy.ai/api/search-image?query=elegant%20women%20suit%20set%20jacket%20detail%20button%20cuff%20waist%20fabric%20quality%20close%20up%20warm%20background%20taiwanese%20designer%20brand%20craftsmanship%20fashion&width=600&height=840&seq=pd005b&orientation=portrait",
      "https://readdy.ai/api/search-image?query=elegant%20mature%20taiwanese%20woman%20wearing%20suit%20set%20office%20lifestyle%20warm%20natural%20light%20editorial%20fashion%20photography%20graceful%20confident%20professional&width=600&height=840&seq=pd005c&orientation=portrait"
    ],
    sizes: [
      { label: "S", chest: "86", waist: "72", hip: "90", length: "62" },
      { label: "M", chest: "90", waist: "76", hip: "94", length: "63" },
      { label: "L", chest: "95", waist: "81", hip: "99", length: "64" },
      { label: "XL", chest: "100", waist: "86", hip: "104", length: "65" }
    ],
    material: "主布：55% 羊毛 + 45% 聚酯纖維\n裡布：100% 聚酯纖維",
    careInstructions: [
      "強烈建議送乾洗（Dry Clean Only）",
      "如需手洗，請用冷水輕柔洗滌",
      "勿機洗、勿漂白、勿高溫烘乾",
      "中溫熨燙，使用熨燙布墊"
    ],
    fitDescription: "版型修身合體，建議依照胸圍與腰圍選尺寸。套裝兩件不一定需同一尺寸，可依個人上下身比例分別選擇。模特兒身高 167cm，穿著 M 號拍攝。",
    stylingTips: [
      "套裝完整穿搭，搭配珍珠耳環提升氣質",
      "拆開搭配：外套搭配花色洋裝，褲子配白色上衣",
      "加上絲質內搭，讓整體更為精緻",
      "搭配低跟穆勒鞋或細跟高跟鞋皆適合"
    ],
    relatedIds: [2, 1, 6]
  },
  {
    id: 6,
    name: "垂墜感印花連身裙",
    tagline: "優雅大方，場合百搭",
    originalPrice: 5200,
    salePrice: 2680,
    badge: "Outlet",
    category: "洋裝系列",
    description: "以台灣設計師品牌獨家印花面料裁製，每一個印花圖案都經過精心設計排列，確保穿著時呈現最美好的視覺效果。V 領設計修飾臉型與頸部，側邊剪裁勾勒出女性自然的身體曲線。",
    highlights: [
      "品牌獨家印花設計，稀有且有收藏價值",
      "V 領設計，修飾臉型同時顯瘦顯優雅",
      "側縫弧線剪裁，自然貼合身型",
      "垂墜感面料，走動間優雅飄逸",
      "聚餐、下午茶、旅行各種場合皆適合"
    ],
    images: [
      "https://readdy.ai/api/search-image?query=elegant%20floral%20print%20midi%20dress%20front%20view%20v%20neck%20draping%20fabric%20worn%20by%20mature%20woman%20cream%20background%20taiwanese%20designer%20outlet%20feminine%20graceful%20quality%20fashion&width=600&height=840&seq=pd006a&orientation=portrait",
      "https://readdy.ai/api/search-image?query=floral%20print%20fabric%20detail%20close%20up%20quality%20printing%20women%20dress%20taiwanese%20designer%20brand%20luxury%20outlet%20warm%20background%20fashion%20photography&width=600&height=840&seq=pd006b&orientation=portrait",
      "https://readdy.ai/api/search-image?query=elegant%20mature%20taiwanese%20woman%20wearing%20floral%20midi%20dress%20outdoor%20garden%20lifestyle%20warm%20light%20editorial%20fashion%20photography%20graceful%20feminine%20quality&width=600&height=840&seq=pd006c&orientation=portrait"
    ],
    sizes: [
      { label: "S", chest: "84", waist: "68", hip: "90", length: "110" },
      { label: "M", chest: "88", waist: "72", hip: "94", length: "111" },
      { label: "L", chest: "93", waist: "77", hip: "99", length: "112" },
      { label: "XL", chest: "98", waist: "82", hip: "104", length: "113" }
    ],
    material: "主布：100% 進口印花縐紗\n裡布：100% 聚酯纖維",
    careInstructions: [
      "建議手洗或送乾洗",
      "冷水輕柔洗滌，避免印花褪色",
      "勿機洗、勿漂白、勿高溫烘乾",
      "低溫熨燙，從裡面熨燙保護印花"
    ],
    fitDescription: "版型合身偏修身，建議依照胸圍選尺寸。裙長至膝下約 10-15 公分，身高較矮者穿著比例絕佳。模特兒身高 162cm，穿著 M 號拍攝。",
    stylingTips: [
      "搭配裸色細跟高跟鞋，突出印花洋裝主角感",
      "外搭同色系薄針織小外套，適合室內冷氣環境",
      "加上小巧金色耳環和細手鍊，展現精緻感",
      "搭配草編包或竹節包，打造度假優雅風格"
    ],
    relatedIds: [1, 5, 10]
  }
];
